<template>
  <div>
    <BasicInfo v-if="selected === 0" />
    <PersonScheme v-if="selected === 1" />
    <OrganisationScheme v-if="selected === 2" />
  </div>
</template>

<script>
import { serverBus } from "../../main";
import BasicInfo from "./BasicInfo";
import PersonScheme from "./PersonScheme";
import OrganisationScheme from "./OrganisationScheme";
import i18n from "@/plugins/i18n";

export default {
  name: "HomePage",
  components: {
    BasicInfo,
    PersonScheme,
    OrganisationScheme
  },
  data: () => ({
    selected: 0
  }),
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    // console.log(i18n.locale, 123456)
    serverBus.$on("selected-tab", index => {
      this.selected = index;
    });
  }
};
</script>
